import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormControl from "@mui/material/FormControl";
import { Select, MenuItem, InputLabel } from "@mui/material";
import Courselist from "../CourseListComponent/Courselist";


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  height: '320px',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  overflowY: 'scroll',
  borderRadius: 1,
  outline: 'none',
  p: 4,
  marginTop: 3,
};

const theme = createTheme({
  palette: {
    neutral: {
      main: '#F0411A',
      contrastText: '#fff',
    },
  },
});

const Modalchapterlist = ({ render, setRender, courses }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [course, setCourse] = useState([]);
  // const [id, setId] = useState('');
  // const [courseList, setCourseList] = useState([]);
  // const [select,setSelect] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // const [age, setAge] = React.useState("");

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };

  // const handleclick = () => {
  //   courses.forEach((el) => {
  //     // course(el?.name)
  //     console.log(el?.name);
  //   });
  //   // console.log(id);
  // };

  // const getCourseList = async () => {
  //   console.log("api url", `api/v1/courses`);
  //   const request = {
  //     method: "get",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //       withCredentials: true,
  //       // Authorization: token,
  //     },
  //   };
  //   // setPending(true);
  //   fetch(`api/v1/courses`, request)
  //     .then((response) => response.json())
  //     .then((res) => {
  //       console.log("user api res", res.courses);
  //       setCourseList(res.courses);
  //       // setPending(false);
  //     })
  //     .catch((err) => console.log("err", err));
  // };

  // useEffect(() => {
  //   getCourseList();
  // }, []);

  const handleCreateChapter = async () => {
    if (!name) {
      toast.warning("please enter name");
      return;
    }
    if (!category) {
      toast.warning("please enter category");
      return;
    }
    if (!course) {
      toast.warning("please enter course");
      return;
    }
    if (!description) {
      toast.warning("please enter description");
      return;
    }
    // let formdata = new FormData();
    // formdata.append("name", name);
    // formdata.append("category",category);
    // formdata.append("description",description);
    // formdata.append("image",image);
    // console.log(formdata);

    try {
      const res = await axios.post(
        `api/v1/a34jl49u-q4r67p89/courses/${course?._id}/chapter`,
        { name, category, description, course },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            withCredentials: true,
            // Authorization: token,
          },
        }
      );
      console.log(res);
      if (res.status === 201 || res.statusText === 'Created') {
        toast.success('success');
        setRender(!render);
        setName('');
        setCategory('');
        setDescription('');
        setCourse([]);
        handleClose();
        return;
      }
    } catch (err) {
      // toast.error(err);
      console.log(err.response.data.message);
      toast.error(err.response.data.message);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Button variant='contained' color='neutral' onClick={handleOpen}>
          Create-Chapter
        </Button>
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          {/* <Typography id="modal-modal-title" variant="h6" component="h2">
            Create Two Digit Lucky Number
          </Typography> */}
          <Typography id='modal-modal-description' sx={{ mt: 2 }}>
            <TextField
              sx={{ width: '100%' }}
              id='outlined-search'
              label='Name'
              type='text'
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            {/* <TextField
              sx={{ width: "100%",marginTop:1 }}
              id="outlined-search"
              label="Course"
              type="text"
            /> */}
            {/* <TextField
              sx={{ width: "100%",marginTop:1 }}
              id="outlined-search"
              label="User"
              type="text"
            /> */}
            {/* <TextareaAutosize
              aria-label="minimum height"
              minRows={3}
              placeholder="Minimum 3 rows"
              style={{ width: '100%',marginTop:15 }}
            /> */}
            <TextField
              sx={{ width: '100%', marginTop: 1, marginBottom: 1 }}
              id='outlined-search'
              label='Category'
              type='text'
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
              }}
            />
            {/* <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="Year"
              type="number"
            />
            <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="Password"
              type="password"
            /> */}
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Course</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={course}
                label="Course"
                onChange={(e) => setCourse(e.target.value)}
              >
                {courses?.map((course, index) => (
                  <MenuItem key={index} value={course}>
                    {course?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <InputLabel>Course</InputLabel>

            <Select
              fullWidth
              size='small'
              value={course}
              placeholder='Course'
              onChange={(e) => setCourse(e.target.value)}
              // onClick={handleclick}
            >
              {courses?.map((course, index) => (
                <MenuItem key={index} value={course}>
                  {course?.name}
                </MenuItem>
              ))}
            </Select> */}
            <TextareaAutosize
              aria-label='minimum height'
              minRows={3}
              placeholder='Description'
              style={{ width: '100%', marginTop: 10 }}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
            <ThemeProvider theme={theme}>
              <Button
                onClick={handleCreateChapter}
                sx={{ marginTop: 3, boxShadow: 'none !important' }}
                variant='contained'
                color='neutral'
              >
                Create
              </Button>
            </ThemeProvider>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default Modalchapterlist;
